"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    notification.classList.add("notification");
    notification.classList.add(type);
    notification.style.position = "absolute";
    notification.style.top = posTop + "px";
    notification.style.right = posRight + "px";
    var notificationTitle = document.createElement("h2");
    notificationTitle.classList.add("title");
    notificationTitle.textContent = title;
    var notificationDescription = document.createElement("p");
    notificationDescription.textContent = description;
    notification.append(notificationTitle);
    notification.append(notificationDescription);
    document.body.append(notification);
    setTimeout(function() {
        notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.db96b437.js.map
